import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { Comment } from "models/Comment";
import { toast } from "react-toastify";
import { MAX_MESSAGE_LENGTH } from "models/Comment";
import { useEditInternalCommentMutation } from "app/api/checklists";
import { useChecklistContext } from "context/ChecklistContext";

type EditCommentDialogProps = { onClose: () => void; comment: Comment };

const EditCommentDialog: React.FC<EditCommentDialogProps> = (props) => {
  const { checklist } = useChecklistContext();
  const { onClose, comment } = props;
  const [commentText, setCommentText] = useState(comment.message);
  const [editInternalComment, { isLoading }] = useEditInternalCommentMutation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCommentText(event.target.value.slice(0, MAX_MESSAGE_LENGTH));
  };

  const handleSave = async () => {
    editInternalComment({
      checklistId: checklist.id,
      commentId: comment.id,
      message: commentText,
    })
      .unwrap()
      .then(() => onClose())
      .catch((error) => {
        console.error(error);
        toast.error("Kunde inte redigera kommentaren. Försök igen senare.");
      });
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth>
      <DialogTitle>Redigera kommentar</DialogTitle>

      <DialogContent dividers>
        <TextField
          type="text"
          variant="filled"
          label="Meddelande"
          autoFocus
          fullWidth
          value={commentText}
          multiline
          rows={4}
          onChange={handleChange}
        />

        <Typography
          fontSize="small"
          color={commentText.length < MAX_MESSAGE_LENGTH ? "textSecondary" : "error"}
          textAlign="right"
          mt={1}
        >
          {commentText.length} / {MAX_MESSAGE_LENGTH} tecken
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" disabled={isLoading} onClick={onClose}>
          Avbryt
        </Button>
        <Button variant="contained" loading={isLoading} onClick={handleSave}>
          Spara
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCommentDialog;
